/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import ApiClient from "./apiClient";

export const toCheckout = async (orderId, navigate) => {
  try {
    const response = await ApiClient.get("/checkout?orderId=" + orderId);
    if (response.redirectUri) {
      navigate(response.redirectUri);
    }
  } catch (error) {
    console.error(error);
    navigate("/servicewelt");
  }
};
